import { useId } from 'react';
import { useIntl } from 'react-intl';
import { Tooltip } from 'react-tooltip';
import { IconHelp } from '@/icons';
import IconButton from './IconButton';

interface HelpTooltipProps {
  text: string;
}

export const HelpTooltip = ({ text }: HelpTooltipProps) => {
  const { formatMessage } = useIntl();
  const id = useId();
  const tooltipId = `${id}-tooltip`;
  const descriptionId = `${id}-description`;

  return (
    <>
      <IconButton
        variant="ghost"
        size="sm"
        round
        icon={<IconHelp aria-hidden="true" />}
        aria-label={formatMessage({ defaultMessage: 'Mer information' })}
        aria-describedby={descriptionId}
        data-tooltip-id={tooltipId}
        data-tooltip-content={text}
      />
      <span id={descriptionId} className="sr-only">
        {text}
      </span>
      <Tooltip
        id={tooltipId}
        delayHide={1}
        opacity={1}
        className="z-50 max-w-xs"
      />
    </>
  );
};
